/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import PropTypes from 'util/PropTypes';
import { Button, SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import dragFields128 from '@ba/ba-graphics/dist/illustrations-js/drag-fields_128';
import StringResources from 'nls/StringResources';
import UnescapedString from 'util/UnescapedString';
import SingleVisDnDHandler from 'util/SingleVisDnDHandler';
import Empty from 'components/empty/Empty';

import './create.scss';

export class _DnDHandler extends SingleVisDnDHandler {
	constructor(options) {
		super(options);
	}

	accepts(dragObject) {
		if (this._dropColumns(dragObject)) {
			return dragObject.data && dragObject.data.utils && dragObject.data.utils.isValid({
				fromCanvas: true
			});
		}
		return super.accepts(dragObject);
	}

	getWidgetSpec(dragObject) {
		if (this._dropColumns(dragObject)) {
			return this._getWidgetSpecOnDropColumns(dragObject);
		}
		return super.getWidgetSpec(dragObject);
	}

	_dropColumns(dragObject) {
		return ['MODEL_ITEM', 'GRID_HEADER_ITEM'].includes(dragObject.type);
	}

	_getWidgetSpecOnDropColumns(dragObject) {
		const canvasDnD = this.dashboardApi.getFeature('CanvasDnD');
		return Promise.resolve(canvasDnD.onDrop(dragObject))
			.then((model) => {
				return {
					model,
					specType: 'widget'
				};
			});
	}

}
@observer
class CreateExplorationLayout extends Component {
	@observable activateDropTarget = false;
	constructor(props) {
		super(props);
		this.services = props.services;
	}
	_onClick(){
		this.props.handleShowVisTypesClick && this.props.handleShowVisTypesClick();
	}
	_onTouchEnd(e){
		e.nativeEvent.preventDefault();
	}

	_handleEnterKey(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			this._onClick();
		}
	}

	render() {
		let message;
		const isComparison = this.props.isComparison;
		if(isComparison) {
			message = StringResources.get('startingPoints_createComparison');
		} else {
			message = StringResources.get('startingPoints_createVisualization');
		}
		void(this.activateDropTarget);
		return (
			<div className="create-exploration create-exploration--droptarget" ref={(node) => { this.domNode = node; }}>
				{this.activateDropTarget && this.getEmptyRenderMarkup()}
				<div className="create-exploration__container">
					{this.props.fill ?
						<SVGIcon className="create-exploration-icon" iconId={dragFields128.id} size="128"/>
						: null}
					<h3>{message}</h3>
					<UnescapedString><p>{StringResources.get('startingPoints_dragAndDrop')}</p></UnescapedString>
					<Button label = {StringResources.get('startingPoints_chooseVisType')} variant="solid" intent="primary" onTouchEnd={this._onTouchEnd.bind(this)} onTouchStart={this._onClick.bind(this)} onClick={this._onClick.bind(this)} onKeyDown={(event) => this._handleEnterKey(event)} />
				</div>
			</div>
		);
	}

	componentDidMount() {
		const options = {
			domNode: this.domNode,
			className: 'dndHover',
			dashboardApi: this.props.dashboardApi,
			createVis: this.props.createVis,
			activate: () => this.activateDropTarget = true,
			deactivate: () => this.activateDropTarget = false
		};
		this.props.services.getSvc('.DndManager').then(
			(dndManager) => {
				dndManager.addDropTarget(
					this.domNode,
					new _DnDHandler(options)
				);
			}
		);
	}
	getEmptyRenderMarkup() {
		return <div className={'explore-empty-create-layout-dnd'}>
			<Empty/>
		</div>;
	}
}

CreateExplorationLayout.propTypes = {
	fill: PropTypes.bool.isRequired,
	services: PropTypes.object.isRequired,
	dashboardApi: PropTypes.object.isRequired,
	createVis: PropTypes.func.isRequired,
	isComparison: PropTypes.bool,
	activeDataSourceId: PropTypes.string,
	handleShowVisTypesClick: PropTypes.func
};

export default CreateExplorationLayout;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/create/CreateExplorationLayout.js